export class ProductWiseTargetStockReq{
    month?:any
    unitId?:number
    constructor(
        month?:any,
    unitId?:number
    ){
this.month = month
this.unitId = unitId
    }
}